import type { TListItemElement } from '@shared/dream-components';
import { ListItemElement } from '@shared/dream-components';
import type { ReactNode } from 'react';

interface Props {
  node: TListItemElement;
  children: ReactNode | ReactNode[];
}

export const ListItem = ({ node, children }: Props) => {
  return <ListItemElement element={node}>{children}</ListItemElement>;
};
